export const PaginationConfig = {
  TotalHitsLimit: 10000
}

export const getTotalHits = (param) => param > PaginationConfig.TotalHitsLimit ? PaginationConfig.TotalHitsLimit : param

export const getTotalPages = (param) => param > PaginationConfig.TotalPages ? PaginationConfig.TotalPages : param



// WEBPACK FOOTER //
// ./src/utils/pagination-config.js